import React from "react";
import { CalendarMonthWrap } from "./CalendarUI";

// Usage:
// <Month name="June" year="2019"></Month>

interface CalendarMonthProps {
    className?: string;
    name: string;
    year: number;
}

const CalendarMonth: React.FC<CalendarMonthProps> = (props) => (
    <CalendarMonthWrap>
        <div className="calendar-month-sticky">
            <h2 className="calendar-month-header">
                <div>
                    <span className="h4 mr-2">{props.name}</span>
                    <span className="h4">{props.year}</span>
                </div>
            </h2>
        </div>
        {props.children}
    </CalendarMonthWrap>
);

export default CalendarMonth;